import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
// PC
import PC from './views/PC.vue'
import PIndex from './views/pc/PIndex.vue'
import PExperience from './views/pc/PExperience.vue'
import PMoreExperience from './views/pc/PMoreExperience.vue'
import PNewsDetail from './views/pc/NewsDetail.vue'
import PRole from './views/pc/PRole.vue'
import PCharacteristic from './views/pc/PCharacteristic.vue'
import PImpression from './views/pc/PImpression.vue'
import PViewpoint from './views/pc/PViewpoint.vue'
// mobile
import Mobile from './views/Mobile.vue'
import MIndex from './views/mobile/MIndex.vue'
import MExperience from './views/mobile/MExperience.vue'
import MNewsDetail from './views/mobile/MNewsDetail.vue'
import MRole from './views/mobile/MRole.vue'
import MCharacteristic from './views/mobile/MCharacteristic.vue'
import MImpression from './views/mobile/MImpression.vue'
import MViewpoint from './views/mobile/MViewpoint.vue'
// 预约模块
import AppointmentIndex from './views/appointment/AppointmentIndex.vue'
import AppointHomeP from './views/appointment/AppointHomeP.vue'
import AppointHomeM from './views/appointment/AppointHomeM.vue'
import PastNew from './views/appointment/PastNew.vue'
import PastOld from './views/appointment/PastOld.vue'
import PumpingCard from './views/appointment/PumpingCard.vue'
import PumpingCardFriend from './views/appointment/PumpingCardFriend.vue'
// 客户端
import PastOldSimplified from './views/gameEmbed/PastOldSimplified.vue'
import PastOldTraditional from './views/gameEmbed/PastOldTraditional.vue'
import AppointHomeG from './views/gameEmbed/AppointHomeG.vue'
import PumpingCardG from './views/gameEmbed/PumpingCardG.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '', name: 'home', component: Home },
    // 官网PC
    { path: '/p-index', component: PC, children: [
      { path: '/', name: 'p-index', component: PIndex },
      { path: '/p-experience', name: 'p-experience', component: PExperience },
      { path: '/p-more-experience', name: 'p-more-experience', component: PMoreExperience },
      { path: '/p-news-detail/:newsId', name: 'p-news-detail', component: PNewsDetail },
      { path: '/p-role', name: 'p-role', component: PRole },
      { path: '/p-characteristic', name: 'p-characteristic', component: PCharacteristic },
      { path: '/p-impression', name: 'p-impression', component: PImpression },
      { path: '/p-viewpoint', name: 'p-viewpoint', component: PViewpoint },
    ] },
    // 官网mobile
    { path: '/m-index', component: Mobile, children: [
      { path: '/', name: 'm-index', component: MIndex },
      { path: '/m-experience', name: 'm-experience', component: MExperience },
      { path: '/m-news-detail/:newsId', name: 'm-news-detail', component: MNewsDetail },
      { path: '/m-role', name: 'm-role', component: MRole },
      { path: '/m-characteristic', name: 'm-characteristic', component: MCharacteristic },
      { path: '/m-impression', name: 'm-impression', component: MImpression },
      { path: '/m-viewpoint', name: 'm-viewpoint', component: MViewpoint },
    ] },
    // 预约新老用户选择
    { path: '/a-index', name: 'a-index', component: AppointmentIndex },
    // 预约主页-PC
    { path: '/appoint-home-p', name: 'appoint-home-pc', component: AppointHomeP },
    // 预约主页-nobile
    { path: '/appoint-home-m', name: 'appoint-home-mobile', component: AppointHomeM },
    // 抽卡
    { path: '/pumping-card', name: 'pumping-card', component: PumpingCard },
    // 好友帮抽
    { path: '/pumping-card-friend', name: 'pumping-card-friend', component: PumpingCardFriend },
    // 情怀-新用户
    { path: '/past-new', name: 'past-new', component: PastNew },
    // 情怀-老用户
    { path: '/past-old', name: 'past-old', component: PastOld },
    // 游戏客户端-情怀-简体
    { path: '/past-old-simplified', name: 'past-old-simplified', component: PastOldSimplified },
    // 游戏客户端-情怀-繁体
    { path: '/past-old-traditional', name: 'past-old-traditional', component: PastOldTraditional },
    // 游戏客户端-预约
    { path: '/appoint-home-g', name: 'appoint-home-g', component: AppointHomeG },
    // 游戏客户端-抽卡
    { path: '/pumping-card-g', name: 'pumping-card-g', component: PumpingCardG },
    // 404
    {path: '*', name: 'notFind', component: () => import('./views/Error404.vue')}
  ]
})